import JsonView from '@uiw/react-json-view';
import { Layers } from 'lucide-react';

import CollapsibleBlock from '../CollapsibleBlock';

const jsonStyle = {
  '--w-rjv-background-color': 'transparent',
  '--w-rjv-font-family':
    'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  '--w-rjv-font-size': '0.75rem',
  '--w-rjv-key-string': '#7c3aed',
  '--w-rjv-color': '#5b21b6',
  '--w-rjv-type-string-color': '#059669',
  '--w-rjv-type-int-color': '#2563eb',
  '--w-rjv-type-boolean-color': '#dc2626',
} as React.CSSProperties;

export default function ModalitiesField({ value }: { value: string }) {
  let modalities: Array<{ type?: string }> | null = null;
  try {
    const parsed = JSON.parse(value);
    modalities = Array.isArray(parsed) ? parsed : [parsed];
  } catch {
    modalities = null;
  }

  const summary = modalities
    ? modalities
        .map((m) => m?.type)
        .filter(Boolean)
        .join(', ')
    : '(unparseable)';

  return (
    <CollapsibleBlock
      icon={<Layers className="h-3.5 w-3.5" />}
      label="Modalities"
      summary={summary}
      tone="purple"
    >
      {modalities ? (
        <JsonView
          value={modalities}
          collapsed={false}
          displayDataTypes={false}
          displayObjectSize={false}
          style={jsonStyle}
        />
      ) : (
        <pre className="whitespace-pre-wrap break-all text-xs">{value}</pre>
      )}
    </CollapsibleBlock>
  );
}
